import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";

import pl from "vuetify/es5/locale/pl";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  lang: {
    locales: {
      pl
    },
    current: process.env.VUE_APP_I18N_LOCALE || "pl"
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#012A2D", // Dark Green
        secondary: "#008E84",
        accent: "#538184", // Sage
        error: "#b71c1c",
        dark: "#004b35"
      }
    }
  }
});
